<template>
  <div class="view page" v-if="page">
    <div class="page-container">
      <h1>{{page.title}}</h1>
      <div class="page-content" v-html="page.content"></div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'page',
  watch: {
    $route() {
      this.$store.commit('setPageLoading', false)
    },
    pageId(id) {
      this.getPage(id)
    }
  },
  computed: {
    ...mapGetters({
      'db': 'getDb',
    }),
    pageId() {
      return this.$route.params.id
    }
  },
  methods: {
    getPage(id) {
      if(this.pageRef) this.pageRef()
      if(id) {
        this.pageRef = this.db().collection('pages').where('slug', '==', id).onSnapshot(page => {
          this.page = page.size ? page.docs[0].data() : null
          this.$store.commit('setPageLoading', false)
        })
      }
    }
  },
  data() {
    return {
      page: null
    }
  },
  mounted: function() {
    this.getPage(this.pageId)
  },
  beforeDestroy: function() {
    if(this.pageRef) this.pageRef()
  }
}
</script>

<style scoped>
.view {
  background: url(../assets/cast_page_banner.jpg) no-repeat top center/1920px auto;
  padding-top: 405px;
}

.page-container {
  width: 800px;
  max-width: calc(100% - 48px);
  margin: auto;
}

.page-container h1 {
  font: bold 4.43em/.84 'Butler';
  max-width: 624px;
}

.page-container .page-content {
  font-size: 1.43em;
  font-weight: 300;
  line-height: 2;
  margin-top: 30px;
}

@media screen and (max-width: 1024px) {
  .view {
    background: none;
    padding-top: 330px;
  }
  .page-container h1 {
    font-size: 48px;
  }
  .page-container .page-content {
    font-size: 18px;
    line-height: 1.77;
  }
}

@media screen and (max-width: 650px) {
  .view {
    padding-top: 260px;
  }
}
</style>

